module.exports = __webpack_public_path__ + "static/images/partials/header/icon-user-auth-467262517a11888008181e5ce7dd8a58.svg";